import { createAction, props } from '@ngrx/store';
import { UserDetailsActionTypes } from './actions.model';
import { User } from '@lockton-apps/shared/interfaces';

export const init = createAction(UserDetailsActionTypes.Init);

export const userDeleted = createAction(
  UserDetailsActionTypes.UserDeleted,
  props<{ user: User }>()
);

export const userEnabled = createAction(
  UserDetailsActionTypes.UserEnabled,
  props<{ user: User }>()
);

export const destroyed = createAction(UserDetailsActionTypes.Destroyed);
